module.exports = __webpack_public_path__ + "img/dateline_1.414b87cf.png";